import React, { useState } from "react";
import { ExclamationTriangleIcon, InformationCircleIcon, SparklesIcon, XMarkIcon, } from "@heroicons/react/24/outline";
import { BannerType } from "ee-nestjs-interfaces";
var bannerDismissedKey = function (id) { return "banner_".concat(id, "_dismissed"); };
var TYPE_ORDER = [
    BannerType.INCIDENT,
    BannerType.INFORMATIONAL,
    BannerType.MARKETING,
];
var getBannerClass = function (type) {
    switch (type) {
        case BannerType.INCIDENT:
            return "bg-red text-white";
        case BannerType.INFORMATIONAL:
            return "bg-yellow-400 text-black-1000";
        case BannerType.MARKETING:
            return "bg-gradient-to-r from-main-gradient-from to-main-gradient-to text-white";
    }
};
var getIconClass = function (type) {
    switch (type) {
        case BannerType.INCIDENT:
            return "w-6 h-6 flex-shrink-0 text-white";
        case BannerType.INFORMATIONAL:
            return "w-6 h-6 flex-shrink-0 text-black-1000";
        case BannerType.MARKETING:
            return "w-6 h-6 flex-shrink-0 text-white";
    }
};
var getIcon = function (type) {
    var iconClass = getIconClass(type);
    switch (type) {
        case BannerType.INCIDENT:
            return React.createElement(ExclamationTriangleIcon, { className: iconClass });
        case BannerType.INFORMATIONAL:
            return React.createElement(InformationCircleIcon, { className: iconClass });
        case BannerType.MARKETING:
            return React.createElement(SparklesIcon, { className: iconClass });
    }
};
/**
 * Displays all active site-specific banners below the site address.
 * Sorted by type: incident > informational > marketing.
 * Marketing banners are suppressed when any incident banner is active, and can be dismissed individually.
 */
export var SiteBanner = function (_a) {
    var banners = _a.banners;
    var _b = useState(0), setDismissCount = _b[1];
    var dismissBanner = function (id) {
        localStorage.setItem(bannerDismissedKey(id), "true");
        setDismissCount(function (n) { return n + 1; });
    };
    if (!banners || banners.length === 0)
        return null;
    var now = new Date();
    var activeBanners = banners.filter(function (b) { return new Date(b.end) > now && new Date(b.start) <= now; });
    if (activeBanners.length === 0)
        return null;
    var hasIncident = activeBanners.some(function (b) { return b.bannerType === BannerType.INCIDENT; });
    var visibleBanners = activeBanners
        .filter(function (b) {
        if (b.bannerType === BannerType.MARKETING && hasIncident)
            return false;
        if (b.bannerType !== BannerType.INCIDENT &&
            localStorage.getItem(bannerDismissedKey(b.id)) === "true")
            return false;
        return true;
    })
        .sort(function (a, b) {
        return TYPE_ORDER.indexOf(a.bannerType) - TYPE_ORDER.indexOf(b.bannerType);
    });
    if (visibleBanners.length === 0)
        return null;
    return (React.createElement("div", { className: "flex flex-col gap-y-2" }, visibleBanners.map(function (banner) { return (React.createElement("div", { key: banner.id, className: "flex flex-row gap-x-3 items-center rounded p-4 relative ".concat(getBannerClass(banner.bannerType)) },
        getIcon(banner.bannerType),
        React.createElement("p", { className: "font-N7 ".concat(banner.bannerType === BannerType.INFORMATIONAL
                ? "text-black-1000"
                : "text-white") }, banner.message),
        banner.bannerType !== BannerType.INCIDENT && (React.createElement(XMarkIcon, { className: "w-5 h-5 absolute right-4 cursor-pointer opacity-70 hover:opacity-100 ".concat(banner.bannerType === BannerType.INFORMATIONAL
                ? "text-black-1000"
                : "text-white"), onClick: function () { return dismissBanner(banner.id); } })))); })));
};
